
const ROStatusEnum = {
    UNASSIGNED:"unassigned",
    NOT_STARTED: "notStarted",
    IN_PROGRESS: "inProgress",
    DELAYED: "delayed",
    FINAL_MINUTES: "finalMinutes",
    COMPLETED: "completed",
    DELETED: "Deleted",
  };
  
  const ROStatusEnumLabels = {
    [ROStatusEnum.UNASSIGNED]: "Unassigned",
    [ROStatusEnum.NOT_STARTED]: "Not Started",
    [ROStatusEnum.IN_PROGRESS]: "In-Progress",
    [ROStatusEnum.DELAYED]: "Delayed",
    [ROStatusEnum.FINAL_MINUTES]: "Final Minutes",
    [ROStatusEnum.COMPLETED]: "Completed",
  };

  const RecordStatusEnum = {
    ACTIVE: "Active",
    IN_ACTIVE: "InActive",
    DELETED: "Deleted",
  };

  const UserRolesEnum = {
    SUPER_ADMIN: "superAdmin",
    ADMIN: "admin",
    SUPERVISOR: "supervisor",
    TECHINICIAN: "technician",
  };

  const UserRolesEnumLabels = {
    [UserRolesEnum.SUPER_ADMIN]: "Super Admin",
    [UserRolesEnum.ADMIN]: "Admin",
    [UserRolesEnum.SUPERVISOR]: "Supervisor",
    [UserRolesEnum.TECHINICIAN]: "Technician",
  };

  module.exports = {
    ROStatusEnum,
    ROStatusEnumLabels,
    RecordStatusEnum,
    UserRolesEnum,
    UserRolesEnumLabels
  };